import intl from 'react-intl-universal';
import { getClipboardData } from '@utils/utils';
import { base64ToBlob } from '@/utils/utils';
import {store} from "Store/store.index";
import { FileData,DATA_TYPE, CONVERT_TYPE,CompressParams, convertApis } from "Api/index";
import { fileController } from "./index";
import {
  // CONVERT_FILES_TO_PDF,
  // CONVERT_HTML_TO_PDF,
  //ORGANIZE_TAB_HEADER_FOOTER,
  CONVERT_EXPORT_IMAGES,
  CONVERT_PDF_TO_WORD,
  CONVERT_PDF_TO_XML_SPREADSHEET_2003,
  CONVERT_PDF_TO_WORD_2003,
  CONVERT_PDF_TO_EXCEL,
  CONVERT_PDF_TO_PPT,
  CONVERT_PDF_TO_PNG,
  CONVERT_PDF_TO_JPEG,
  CONVERT_PDF_TO_JPEG2000,
  CONVERT_PDF_TO_TIFF,
  CONVERT_PDF_TO_BMP,
  CONVERT_PDF_TO_RTF,
  CONVERT_PDF_TO_TXT,
  CONVERT_PDF_TO_HTML,
  CONVERT_PREFLIGHT,
} from '../ui/constants/convert.constants';
import { ORGANIZE_TAB_SPLIT} from "../ui/constants/organize.constants";
import { FILE_TAB_PDF_OPTIMIZER } from "../ui/constants/file.constants";
import { TASK_STATUS } from "Api/constants";
import { getApiParams, CONVERT_OBJECT_EXCEL, CONVERT_OBJECT_POWERPOINT, CONVERT_OBJECT_WORD } from '../../dialogs/ConvertToPDF/utils';
import {isValidURL} from "Utils/utils"
import { getFileBufferByUrl, otelApi} from 'Api/index';
// import { storageGetItem } from "@/utils/utils";
// import { CHECKED_TOC_FOR_COMBINE } from "@/constants/local.constant";
const html2pdfDefaultSetting =
{
  "width": 595,//宽
  "height": 842,//高
  "top": 18,//位置
  "right": 18,//位置
  "bottom": 18,//位置
  "left": 18,//位置
  "rotate": 0,//0:no rotate;1:90 degrees;2:180 degress;3:270 degress
  "timeout": 120,
  "isConvertLink": true, //是否不转换link
  "pageMode": "1",//是否单页模式
  "toGenerateBookmarks":false,//Create bookmarks
  "isGenerateTag":true,
  "isOptTagTree":false
}
export default class ConvertController  {
    constructor(){
        this.pdfui = null;
        this.currentUrlList=[];
        this.doPDFToTxt = this.doPDFToTxt.bind(this);
        this.getTaskTypeByTaskName = this.getTaskTypeByTaskName.bind(this);
        this.getTaskTypeByFileName = this.getTaskTypeByFileName.bind(this);
        this.getTargetFileName = this.getTargetFileName.bind(this);
        this.getFileTypeByTaskName = this.getFileTypeByTaskName.bind(this);
        this.doToImages = this.doToImages.bind(this);
        this.doSplitPDF = this.doSplitPDF.bind(this);
        this.doReduceFileSize = this.doReduceFileSize.bind(this);
        this.doOptimizePDF = this.doOptimizePDF.bind(this);
        this.insertPages = this.insertPages.bind(this);
        this.appendUrlsOnCurrentPDF = this.appendUrlsOnCurrentPDF.bind(this);
        this.linkDoHtml2PDF = this.linkDoHtml2PDF.bind(this);
        this.doConvertPDFPreflight = this.doConvertPDFPreflight.bind(this);
        this.saveAsPDFPreflight = this.saveAsPDFPreflight.bind(this);
        this.doPreflightProfiles = this.doPreflightProfiles.bind(this);
    }
    getTargetFileName(sourceName, isToPDF, taskName, part){
        part = !part?'':part;
        let index = sourceName.lastIndexOf('.');
        let pre = sourceName.substring(0, index);
        if(isToPDF){
            return pre + part + ".pdf";
        }
        if(!taskName){
            return null;
        }
        let post = this.getFileTypeByTaskName(taskName);
        if(post){
            return pre + post;
        }
        return null;
    }
    getFileTypeByTaskName(name){
        switch (name) {
            case CONVERT_PDF_TO_WORD:{
                return '.docx';
            }
            case CONVERT_PDF_TO_WORD_2003:{
                return '.doc';
            }
            case CONVERT_PDF_TO_EXCEL:{
                return '.xlsx';
            }
            case CONVERT_PDF_TO_XML_SPREADSHEET_2003:{
                return '.xml'
            }
            case CONVERT_PDF_TO_PPT:{
                return '.pptx';
            }
            case CONVERT_EXPORT_IMAGES:
            case CONVERT_PDF_TO_PNG:
            case CONVERT_PDF_TO_JPEG:
            case CONVERT_PDF_TO_JPEG2000:
            case CONVERT_PDF_TO_TIFF:
            case CONVERT_PDF_TO_BMP:
            case ORGANIZE_TAB_SPLIT:{
                return '.zip';
            }
            case CONVERT_PDF_TO_HTML:{
                return '.html';
            }
            case CONVERT_PDF_TO_RTF:{
                return '.rtf';
            }
            case CONVERT_PDF_TO_TXT:{
                return '.txt';
            }
            case CONVERT_PREFLIGHT:
            case FILE_TAB_PDF_OPTIMIZER:{
                return '.pdf';
            }
            default:
                break;
        }
        return null;
    }
    getTaskTypeByFileName(fileName) {
        return store.taskStore.getTaskTypeByFileName(fileName)
    }

    getTaskTypeByTaskName(name){
        switch (name) {
            case CONVERT_PDF_TO_WORD:{
                return CONVERT_TYPE.PDFTOWORD;
            }
            case CONVERT_PDF_TO_WORD_2003:{
                return CONVERT_TYPE.PDFTOWORD2003;
            }
            case CONVERT_PDF_TO_EXCEL:{
                return CONVERT_TYPE.PDFTOEXCEL;
            }
            case CONVERT_PDF_TO_XML_SPREADSHEET_2003:{
                return CONVERT_TYPE.PDFTOXMLSPREADSHEET2003
            }
            case CONVERT_PDF_TO_PPT:{
                return CONVERT_TYPE.PDFTOPPT;
            }
            case CONVERT_EXPORT_IMAGES:
            case CONVERT_PDF_TO_PNG:
            case CONVERT_PDF_TO_JPEG:
            case CONVERT_PDF_TO_JPEG2000:
            case CONVERT_PDF_TO_TIFF:
            case CONVERT_PDF_TO_BMP:{
                return CONVERT_TYPE.PDFTOIMG;
            }
            case CONVERT_PDF_TO_HTML:{
                return CONVERT_TYPE.PDFTOHTML_SOLID;
            }
            case CONVERT_PDF_TO_RTF:{
                return CONVERT_TYPE.PDFTORTF;
            }
            case CONVERT_PDF_TO_TXT:{
                return CONVERT_TYPE.PDFTOTXT;
            }
            default:
                break;
        }
        return null;
    }

  getDocPassword = async () => {
    const pdfDoc = pdfui.pdfViewer.currentPDFDoc;
    if(!pdfDoc) return '';
    const securityUtils = window.PDFViewCtrl.shared.securityUtils;
    const {ownerPassword} = securityUtils.getPermissionDefaultUIData('password');
    const userPassword = await pdfDoc.getUserPassword(ownerPassword) ||'';
    return userPassword;
  }

  doPDFToOthers(taskName, cfg, success, error) {

    let confText=JSON.parse(cfg.confText)
    let type;
    if (confText && confText.export_engine && confText.export_engine === 'image_based') {
      type = 35;
    } else {
      type = this.getTaskTypeByTaskName(taskName);
    }
    if (type < 0) {
      console.error("TCL: ConvertController -> doPDFToOthers -> type, can not find:", type);
      return;
    }

    let activeContext = otelApi.activeContext();
    let traceHeaders = otelApi.injectTraceHeaders(activeContext)
    const getDocBufferSpan = otelApi.startSpan('getDocBuffer', {}, activeContext);

    store.accountStore.updateTrialPermission(taskName);
    store.taskStore.setHasTask(true);
    store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, type);
    fileController.getCurrentDocBuffer().then(async ([buffers, fileName]) => {
      otelApi.endSpan(getDocBufferSpan);
      const getDocPassSpan = otelApi.startSpan('getDocPass', {}, activeContext);

      const { downloadFileName, ...otherCfg } = cfg || {};
      otherCfg.headers = traceHeaders;

      const fileData = new FileData(buffers, fileName, DATA_TYPE.FileBuffer, '', 0);
      fileData.password = await this.getDocPassword();
      otelApi.endSpan(getDocPassSpan);

      const convertFileSpan = otelApi.startSpan('convertFile', {}, activeContext);
      store.taskStore.convertFile(fileData, type, otherCfg, (result) => {
        if (result !== 'stop') result.fileName = downloadFileName;

        const status = {
          code:1,
          message: `${result?.status}`
        };
        otelApi.setSpanStatus(convertFileSpan,status);
        if (result.ret === 0 && result.url) {
          otelApi.endSpan(convertFileSpan);
        }

        result.activeContext = activeContext;
        success && success(result);
      }, (err) => {
        console.error("TCL: ConvertController -> doPDFToOthers -> error", err);

        otelApi.setSpanAttribute(convertFileSpan, 'error', true);
        otelApi.endSpan(convertFileSpan);

        error && error(err);
      });
    });
  }

  doConvertPDFFile_noTips(taskName, callback, error){
    let type = this.getTaskTypeByTaskName(taskName);
    if(type <0){
      if(process.env.NODE_ENV == 'development'){
        console.error("TCL: ConvertController -> doConvertFile -> type, can not find:", type)
        return;
      }
    }
    //
    store.accountStore.updateTrialPermission(taskName);
    store.taskStore.setHasTask(true);
    fileController.getCurrentDocBuffer().then(([buffers,fileName])=>{
      let fileData = new FileData(buffers, fileName, DATA_TYPE.FileBuffer, '', 0);
      store.taskStore.convertFile(fileData, type, null, (result)=>{
          if (result!='stop') result.fileName = this.getTargetFileName(fileName, false, taskName);
          callback && callback(result);
        },(err)=>{
          if(process.env.NODE_ENV == 'development'){
            console.error("TCL: doConvertFile -> error", err)
            error && error(err);
          }
        },
        false)
    })
  }
    //urllink转换后插入当前文档和更改link类型操作
    async insertPages(urlInfo,fileObj,urlsArr,res,errorStatusCallBack,updateStatusCallBack) {
        let pdfDoc=await pdfui.getPDFDocByFileNoOpen(fileObj);
        //pdf读取失败时候处理
        if(pdfDoc.code){
            errorStatusCallBack&&errorStatusCallBack(urlInfo,res);
            return;
        }
        //获取转换后pdf文档的总页码
        let pdfPages=pdfDoc.getPageCount();
        let doc=await pdfui.getCurrentPDFDoc();
        //当前文档的最后页码数
        let destIndex=doc.getPageCount();
        //将转换后pdf插入当前文档
        let docId=pdfDoc.getId();
        let srcPages=[]
        for(let i=0;i<pdfPages;i++){
            srcPages.push(i)
        }
        let srcDocs=[
            {
                srcDocId:docId,
                srcPages
            }
        ]
        //目前针对annot位于第一页或者其他页面的情况做个action设置区分
        let currentPageIndex=fileController.getCurrentPageIndex()
        let annot;
        if(currentPageIndex!==0){
          //获取link，并将其改为gotolink类型
          let annots = await fileController.getAnnotsByPageIndex();
          annot = annots.filter((item) => {
              let linkType = item.info.action && item.info.action.type;
              if (linkType === 'TypeURI') {
                  return item.info.action.uri == urlInfo.Url
              }
          })
          let action = new PDFViewCtrl.PDF.actions.GoToAction();
          if (annot.length !== 0) {
              await annot[0].setAction(action);
          }
  
        }
        doc.importPagesFromPDFDocs({destIndex,srcDocs}).then(async ()=>{
          if(currentPageIndex===0){
            setTimeout(async () => {
                let annots = await fileController.getAnnotsByPageIndex();
                annot = annots.filter((item) => {
                    let linkType = item.info.action && item.info.action.type;
                    if (linkType === 'TypeURI') {
                        return item.info.action.uri == urlInfo.Url
                    }
                })
                let action = new PDFViewCtrl.PDF.actions.GoToAction();
                let actionData = await fileController.getActionDataByGoToLink(destIndex);
                //成功插入文档后，再去设置gotolink的参数
                if (annot.length !== 0) {
                    await annot[0].setAction(action);
                    await annot[0].setActionData(actionData);
                }
            }, 0)
          }else{
            let actionData = await fileController.getActionDataByGoToLink(destIndex);
            //成功插入文档后，再去设置gotolink的参数
            if (annot.length !== 0) {
                await annot[0].setActionData(actionData);
            }
          }
          
          //插入成功后列表项去除
          let newtodos = urlsArr.filter((t) => { return(t.key !== urlInfo.key) });
          this.currentUrlList=newtodos;
          updateStatusCallBack&&updateStatusCallBack(newtodos);
          res();
      })
        
    }
    /**
     *
     *
     * @param {Object} setting
     * @param {Object} urlsArr
     * @param {Function} updateStatusCallBack
     * @param {Function} errorStatusCallBack
     * @param {Function} successCallBack
     * @memberof appendUrlsOnCurrentPDF
     * link功能html2pdf转换
     */
    appendUrlsOnCurrentPDF(setting,urlsArr,updateStatusCallBack,errorStatusCallBack,successCallBack){
        this.currentUrlList=urlsArr;
         //对于没设置setting的url进行默认的配置
        if(!setting) setting=html2pdfDefaultSetting;
        let task = Promise.resolve();
        urlsArr.map((urlInfo) => {
            task = task.then(
              () =>
                new Promise((res,rej) => {
                  urlInfo.Status=intl.formatMessage({ id: 'AppendWebLinks.Downloading' })
                  let fileData = urlInfo.file;
                  //转换文件时候如果是pdf格式，直接插入
                  if(urlInfo.file.dataType==="File"&&urlInfo.file.file.type==="application/pdf"){
                    let fileObj1= urlInfo.file.file;
                    this.insertPages(urlInfo,fileObj1,this.currentUrlList,res,errorStatusCallBack,updateStatusCallBack);
                    return;
                  }
                  //非法url时候
                  if(urlInfo.file.dataType!=="File"){
                    let url=urlInfo.Url.replace(/^\s*|\s*$/g,"");
                    let isValid = isValidURL(url);
                    if(!isValid){
                        errorStatusCallBack&&errorStatusCallBack(urlInfo,res);
                      return;
                    }
                  }
                  this.linkDoHtml2PDF(
                    fileData,
                    setting,
                    (result) => {
                      if(result=="stop"){
                        return rej();
                      }
                      //更新状态
                      updateStatusCallBack&&updateStatusCallBack(this.currentUrlList);
                      if (result && result.ret == 0 && result.url) {
                        const { url } = result;
                        if(url){
                          let fileObj;
                          getFileBufferByUrl(url, (resource) => {
                            const fileData = new FileData(resource, urlInfo.name, DATA_TYPE.FileBuffer, '', 0);
                            let fileName=store.taskStore.htmlFileName;
                            //TODO此处传入后端返回的filename
                            fileObj = new File([fileData.file], fileName,{type:"application/pdf"});
                            //点击stop
                            const {hasTask} = store.taskStore;
                            if(hasTask){
                              this.insertPages(urlInfo,fileObj,this.currentUrlList,res,errorStatusCallBack,updateStatusCallBack);
                            }
                          })
                        }
                      }
                    },
                    () => {
                        errorStatusCallBack&&errorStatusCallBack(urlInfo,res);
                    },
                  );
                })
            );
        });
        task.then(() => {
            successCallBack&&successCallBack()
        });
    }
    /**
     *
     *
     * @param {FileData} fileData
     * @param {Object} cfg
     * @param {Function} callback
     * @param {Function} error
     * @memberof ConvertController
     * link功能html2pdf转换
     */
    linkDoHtml2PDF(fileData, cfg, callback, error){
        store.taskStore.setHasTask(true);
        let options = {
            confText: JSON.stringify(cfg),
            fileIndexList: "",
            overlayText: "",
            pageOrganizer: "",
            redactText: ""
        }
        if(fileData.dataType === DATA_TYPE.Url){
            options.url = fileData.file;
            store.taskStore.convertUrlToPDFNoProgress(CONVERT_TYPE.HTML2PDF, options, (result)=>{
                result.fileName = this.getTargetFileName('html2pdf.url', true);

                callback && callback(result);
            },(err)=>{
                error && error(err);
                if(process.env.NODE_ENV == 'development'){
                    console.error("TCL: doHtml2PDF -> error", err)
                }
            })
            return;
        }
        let type =  this.getTaskTypeByFileName(fileData.fileName);

        store.taskStore.convertFile(fileData,type, options, (result)=>{
            if (result!='stop') {
                store.taskStore.setHasTask(true);
                store.docStore.setIsConverted(true);
            }

            callback && callback(result);
        },(err)=>{
            if(process.env.NODE_ENV == 'development'){
                console.error("TCL: doPDFToTxt -> error", err)
                error && error(err);
            }
        },false)
    }
    /**
     *
     *
     * @param {FileData} fileData
     * @param {Object} cfg
     * @param {Function} callback
     * @param {Function} error
     * @memberof ConvertController
     */
    doHtml2PDF(fileData, cfg, callback, error,showSpin=true){
        store.taskStore.setHasTask(true);
        showSpin&&store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, CONVERT_TYPE.HTML2PDF);
        let options = {
            confText: JSON.stringify(cfg),
            fileIndexList: "",
            overlayText: "",
            pageOrganizer: "",
            redactText: ""
        }

        if(fileData.dataType === DATA_TYPE.Url){
            options.url = fileData.file;
            store.taskStore.convertUrlToPDF(CONVERT_TYPE.HTML2PDF, options, (result)=>{
                result.fileName = this.getTargetFileName('html2pdf.url', true);
                
                callback && callback(result);
            },(err)=>{
                error && error(err);
                if(process.env.NODE_ENV == 'development'){
                    console.error("TCL: doHtml2PDF -> error", err)
                }
            })
            return;
        }
        
        store.taskStore.convertFile(fileData, CONVERT_TYPE.HTML2PDF, options, (result)=>{
            if (result!='stop') {
                result.fileName = this.getTargetFileName('html2pdf.url', true);
                store.docStore.setIsConverted(true);
            }
            callback && callback(result);
        },(err)=>{
            if(process.env.NODE_ENV == 'development'){
                console.error("TCL: doPDFToTxt -> error", err)
                error && error(err);
            }
        })
    }

  doClipboard2PDF() {
    getClipboardData().then(data => {
      if (!data) return;

      const { type, blob } = data;

      let fileName = 'Untitled.pdf';
      if (store.appStore.isIncludeFoxitStorage && !store.storageAppStore.isDisableStorage) {
        fileName = store.storageAppStore.getBlankFileName();
      }

      const doConvertAndOpen = file => {
        this.doConvertToPDF(file, result => {
          if (result && result !== 'stop' && result.ret === 0 && result.url) {
            fileController.doOpenFileByUrl(result.url, fileName, undefined, undefined, () => {
              store.appStore.doUpdateDocModified(true);
            });
            result.url = '';
            setTimeout(() => store.taskStore.setTaskMessage(null), 0);
          }
        });
      };
      
      if (type === 'text/html') {
        const file = new File([blob], 'Untitled.html', { type });
        doConvertAndOpen(file);
      } else if (type.indexOf('image/') > -1) {
        const url = URL.createObjectURL(blob);
        const img = document.createElement('img');
        img.onload = () => {
          URL.revokeObjectURL(url);
          pdfui.createNewDoc(fileName, undefined, { height: img.naturalHeight, width: img.naturalWidth }).then(pdfDoc => {
            if (!pdfDoc) return;
            pdfDoc.getPageByIndex(0).then(pdfPage => {
              blob.arrayBuffer().then(arraybuffer => {
                const rect = { left: 0, bottom: 0, right: pdfPage.getWidth(), top: pdfPage.getHeight() };
                pdfPage.addImage(arraybuffer, rect);
              });
            });
          });
        };
        img.src = url;
      } else if (type === 'text/plain') {
        const file = new File([blob], 'Untitled.txt', { type });
        doConvertAndOpen(file);
      }
    });
  }
    doPDFToXmlStardardByGSDK(fileName, success, taskName) {
        store.taskStore.setHasTask(true);
        const pdfDoc = pdfui.pdfViewer.currentPDFDoc;
        const cancelHandler = () => {
            pdfDoc.cancelExportToImage();
        };
        store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_BY_GSDK, progress: 0, cancelHandler });
        let files = {};
        let exportToXmlCallback = result => {
            if (!result || !store.taskStore.hasTask) return;
            const { fileName: fileNameOutput, imgBuffer, xmlBuffer, percent } = result;
            if (fileNameOutput && imgBuffer) {
                files[fileNameOutput] = imgBuffer;
            }
            if (percent < 100) {
                store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.DOING_BY_GSDK, progress: percent, cancelHandler });
            } else {
                store.accountStore.updateTrialPermission(taskName);
                //判断当前文档是否有图片资源，有的话以压缩包形式下载
                if (imgBuffer) {
                    import('jszip')
                    .then(JSZip=>{
                      const zip = new JSZip.default();
                      if (Object.keys(files).length) {
                          for (const fileNameOutput in files) {
                              zip.file(fileNameOutput, files[fileNameOutput], { binary: true });
                          }
                      }
                      zip.file(fileName, xmlBuffer[0], { binary: true });
                      zip.generateAsync({ type: 'blob' }).then(blob => {
                          const fileNamePrefix = fileName.substr(0, fileName.lastIndexOf('.'));
                          store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.FINISH_BY_GSDK, blob, downloadName: `${fileNamePrefix}.zip` });
                          store.taskStore.setHasTask(false);
                          success && success(blob);
                      });
                    })
                } else {
                    let blob = new Blob([...xmlBuffer], { type: fileName })
                    store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.FINISH_BY_GSDK, blob, downloadName: fileName });
                    store.taskStore.setHasTask(false);
                    success && success(blob);
                }

            }
        };
        pdfDoc.exportToStardardXml(fileName, exportToXmlCallback).catch(() => {
            store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.ERROR_BY_GSDK });
            store.taskStore.setHasTask(false);
        });
    }

    doToImages(cfgOption, setting, callback, error) {
        store.taskStore.setHasTask(true);
        store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, CONVERT_TYPE.PDFTOIMG);
        fileController.getCurrentDocBuffer().then(([buffers, fileName]) => {
            const fileData = new FileData(buffers, fileName, DATA_TYPE.FileBuffer, '', 0);
            const cfg = {
              confText: JSON.stringify(cfgOption),
              fileIndexList: '',
              overlayText: '',
              pageOrganizer: '',
              redactText: '',
            }
          store.taskStore.convertFile(fileData, CONVERT_TYPE.PDFTOIMG, cfg, (result) => {
                if (result!='stop') result.fileName = this.getTargetFileName(setting.fileName, false, setting.taskName);
                
                callback && callback(result);
            }, (err) => {
                if (process.env.NODE_ENV == 'development') {
                    console.error("TCL: doPDFToTxt -> error", err);
                    error && error(err);
                }
            });
        });
    }
  doPDFToTxtByGSDK(pageRange, fileName, success, taskName) {
    store.taskStore.setHasTask(true);
    const pdfDoc = pdfui.pdfViewer.currentPDFDoc;
    const cancelHandler = () => {
      pdfDoc.cancelExport();
    };
    store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_BY_GSDK, progress: 0, cancelHandler });
    const callback = result => {
      if (!result || !store.taskStore.hasTask) return;
      const { buffer, percent } = result;
      if (percent < 100) {
        store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.DOING_BY_GSDK, progress: percent, cancelHandler });
      } else {
        store.accountStore.updateTrialPermission(taskName);
        let blob = new Blob([...buffer], { type: 'text/plain' })
        store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.FINISH_BY_GSDK, blob, downloadName: fileName });
        store.taskStore.setHasTask(false);
        success && success(blob);
      }
    };
    pdfDoc.exportToTxt(taskName, pageRange, callback).catch(e => {
      store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.ERROR_BY_GSDK, info: e.message });
      store.taskStore.setHasTask(false);
      process.env.NODE_ENV === 'development' && console.error(e);
    });
  }
    doPDFToImagesByGSDK(graphicsObject, pageRange, imageSetting, fileName, success, error, taskName) {
      store.taskStore.setHasTask(true);
      const pdfDoc = pdfui.pdfViewer.currentPDFDoc;
      const cancelHandler = () => {
        pdfDoc.cancelExport();
      };

      let isExportImages = imageSetting.type === 'imageObjsOfPage';
      
      store.taskStore.onUpdateTaskMessage({ status: isExportImages ? TASK_STATUS.BEGIN_BY_GSDK_EXPORT_IMAGES : TASK_STATUS.BEGIN_BY_GSDK, progress: 0, cancelHandler})
      imageSetting.dpi = window.PDFViewCtrl.shared.browser.getDPI();
      let graphicsObjectInfo;
      if (graphicsObject) {
        graphicsObject.graphicsObject.page.info.selectPosition = graphicsObject.selectPosition;
        graphicsObjectInfo = graphicsObject.graphicsObject.page.info;
        //选中图片时候的回调
        let exportImageObjectToImageCallback = result => {
          if (!result || !store.taskStore.hasTask) return;
          const { buffer, percent } = result;
          if (percent < 100) {
            store.taskStore.onUpdateTaskMessage({ status: isExportImages ? TASK_STATUS.DOING_BY_GSDK_EXPORT_IMAGES : TASK_STATUS.DOING_BY_GSDK, progress: percent, cancelHandler})
          } else {
            store.accountStore.updateTrialPermission(taskName);
            let blob = new Blob([buffer], { type: fileName })
            store.taskStore.onUpdateTaskMessage({ status: isExportImages ? TASK_STATUS.FINISH_BY_GSDK_EXPORT_IMAGES : TASK_STATUS.FINISH_BY_GSDK, blob, downloadName: fileName })
            store.taskStore.setHasTask(false);
            success && success(blob);
          }
        };
        pdfDoc.exportImageObjectToImage(graphicsObjectInfo, imageSetting, fileName, exportImageObjectToImageCallback).catch(e => {
          store.taskStore.onUpdateTaskMessage({ status: isExportImages ? TASK_STATUS.ERROR_BY_GSDK_EXPORT_IMAGES : TASK_STATUS.ERROR_BY_GSDK,info: e.message })
          store.taskStore.setHasTask(false);
          process.env.NODE_ENV === 'development' && console.error(e);
        });
      } else {
        const files = {};
        let exportToImageCallback = result => {
          if (!result || !store.taskStore.hasTask) return;

          const { fileName: fileNameOutput, buffer, percent } = result;
          if (fileNameOutput && buffer) {
            files[fileNameOutput] = buffer;
          }
          if (percent < 100) {
            store.taskStore.onUpdateTaskMessage({ status: isExportImages ? TASK_STATUS.DOING_BY_GSDK_EXPORT_IMAGES : TASK_STATUS.DOING_BY_GSDK, progress: percent, cancelHandler })
          } else {
            store.accountStore.updateTrialPermission(taskName);
            if (Object.keys(files).length) {
              import('jszip')
              .then(JSZip=>{
                const zip = new JSZip.default();
                for (const fileNameOutput in files) {
                  zip.file(fileNameOutput, files[fileNameOutput], { binary: true });
                }
                zip.generateAsync({ type: 'blob' }).then(blob => {
                  const fileNamePrefix = fileName.substr(0, fileName.lastIndexOf('.'));
                  store.taskStore.onUpdateTaskMessage({ status: isExportImages ? TASK_STATUS.FINISH_BY_GSDK_EXPORT_IMAGES : TASK_STATUS.FINISH_BY_GSDK, blob, downloadName: `${fileNamePrefix}.zip` })
                  store.taskStore.setHasTask(false);
                  success && success(blob);
                });
              })
            } else {
              store.taskStore.setTaskMessage(null);
              store.taskStore.setHasTask(false);
              store.appStore.onShowWarningMessage(null, {
                message: 'Convert.ExportAllImages.Fail',
                title: 'PhantomPDF.Online.TitleWithOnline',
              }, true);
              error && error('without images');
            }
          }
        };
        pdfDoc.exportToImage(imageSetting, fileName, pageRange, exportToImageCallback).catch(e => {
          store.taskStore.onUpdateTaskMessage({ status: isExportImages ? TASK_STATUS.ERROR_BY_GSDK_EXPORT_IMAGES : TASK_STATUS.ERROR_BY_GSDK, info: e.message })
          store.taskStore.setHasTask(false);
          process.env.NODE_ENV === 'development' && console.error(e);
        });
      }

      
      
    }
    doSplitPDF({isPdf, cfgOption, callback, error}) {
        store.taskStore.setHasTask(true);

        let cfg = {
            confText: JSON.stringify(cfgOption),
            fileIndexList: "",
            overlayText: "",
            pageOrganizer: "",
            redactText: ""
        }

        store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, CONVERT_TYPE.SPLITPDF);
        fileController.getCurrentDocBuffer().then(([buffers,fileName])=>{
            let fileData = new FileData(buffers, fileName, DATA_TYPE.FileBuffer, '', 0);

            cfg.destFileName = fileName
            store.taskStore.convertFile(fileData, CONVERT_TYPE.SPLITPDF, cfg, (result)=>{
                if (result!='stop') result.fileName = this.getTargetFileName(fileName, isPdf, ORGANIZE_TAB_SPLIT);
                
                callback && callback(result);
            },(err)=>{
                if(process.env.NODE_ENV == 'development'){
                    console.error("TCL: doSplitPDF -> error", err)
                    error && error(err);
                }
            })
        })
    }
  //comment-导出comment到word
  doImportComment(cfg, callback, error) {
    store.taskStore.setHasTask(true);
    store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, CONVERT_TYPE.COMMENT_COMBINE);
    store.taskStore.doImportCommentTask(cfg, (result) => {
      callback && callback(result)
    }, (errorMsg) => {
      error && error(errorMsg)
    })
  }
    doReduceFileSize(callback, error){
        this.doOptimizePDF({isPdf:true, cfgOption:CompressParams,callback, error});
    }
    doOptimizePDF({isPdf, cfgOption, callback, error}){
        store.taskStore.setHasTask(true);

        let cfg = {
            confText: JSON.stringify(cfgOption),
            fileIndexList: "",
            overlayText: "",
            pageOrganizer: "",
            redactText: ""
        }

        store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, CONVERT_TYPE.OPTIMIZER);

        fileController.getCurrentDocBuffer().then(([buffers,fileName])=>{
            let fileData = new FileData(buffers, fileName, DATA_TYPE.FileBuffer, '', 0);

            cfg.destFileName = fileName;

            store.taskStore.convertFile(fileData, CONVERT_TYPE.OPTIMIZER, cfg, (result)=>{
                if (result!='stop') result.fileName = this.getTargetFileName(fileName, isPdf, FILE_TAB_PDF_OPTIMIZER);
                
                callback && callback(result);
            },(err)=>{
                if(process.env.NODE_ENV == 'development'){
                    console.error("TCL: doOptimizePDF -> error", err)
                    error && error(err);
                }
            })
        })
    }
    /**
     *
     *
     * @param {FileData[]} fileList
     * @param {Function} error
     * @returns {{id:String,taskId:Number, task:Task}}
     */
    doUploadMultifiles(fileList, error){
        store.taskStore.setHasTask(true);
        let list = store.taskStore.doUploadMultiFiles(fileList, error);
        return list;
    }

    doCombineMultifiles(seqList,options, callback, error, showSpin=true){
        let cfg = {
            confText: JSON.stringify(options),
            fileIndexList: "",
            overlayText: "",
            pageOrganizer: "",
            redactText: "",
        } 
        // const isAddTOC = JSON.parse(storageGetItem(localStorage, CHECKED_TOC_FOR_COMBINE))

        // if (isAddTOC) {
        //     Object.assign(cfg, {confText: JSON.stringify({isAddTOC: true})}) 
        // }

        showSpin&&store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.COMBINE, ret: 0 }, CONVERT_TYPE.MERGEPDF);
        store.taskStore.doCombineMultifiles(seqList, cfg, (result)=>{
            if(result!=='stop')
                store.docStore.setIsConverted(true);
            callback && callback(result);
        }, (err)=>{
            if(process.env.NODE_ENV == 'development'){
                console.error("TCL: doCombineMultifiles -> err", err)
                error && error(err);
            }
        })
    }
    doAddHeaderFooter(setting, callback, error){
        //ORGANIZE_TAB_HEADER_FOOTER
        store.taskStore.setHasTask(true);
        let confText = typeof setting === 'string'?setting:JSON.stringify(setting);
        let cfg = {
            confText,
            fileIndexList: "",
            overlayText: "",
            pageOrganizer: "",
            redactText: ""
        } 
        store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, CONVERT_TYPE.PDFHEADERFOOTER);
        fileController.getCurrentDocBuffer().then(([buffers,fileName])=>{
            let fileData = new FileData(buffers, fileName, DATA_TYPE.FileBuffer, '', 0);
            store.taskStore.convertFile(fileData, CONVERT_TYPE.PDFHEADERFOOTER, cfg, (result)=>{
                if (result!='stop') result.fileName = fileName;//this.getTargetFileName(fileName, false, CONVERT_PDF_TO_IMAGE);
                
                callback && callback(result);
            },(err)=>{
                if(process.env.NODE_ENV == 'development'){
                    console.error("TCL: doAddHeaderFooter -> error", err)
                    error && error(err);
                }
            })
        })
    }

  doConvertToPDF(file, callback, error, isBlob, showSpin = true) {
    let fileName = file.name;
    let type = this.getTaskTypeByFileName(file.name);
    if (type === CONVERT_TYPE.UNKNOWN) {
      // TODO show message 'Not Support' NotSupportedFormat
      store.taskStore.setTaskMessage({ info: "NotSupportedFormat", type: 'error', failed: true }, 5000);
      error && error('NotSupportedFormat');
      return;
    }
    store.taskStore.setHasTask(true);
    showSpin && store.taskStore.onUpdateTaskMessage({ fileName, status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, type);

    const confTextObj = getApiParams({
      [CONVERT_TYPE.EXCELTOPDF]: CONVERT_OBJECT_EXCEL,
      [CONVERT_TYPE.PPTTOPDF]: CONVERT_OBJECT_POWERPOINT,
      [CONVERT_TYPE.WORDTOPDF]: CONVERT_OBJECT_WORD,
    }[type]);

    const convertHandle = (cfg = {}) => {
      let fileData = new FileData(file, file.name, isBlob ? DATA_TYPE.FileBuffer : DATA_TYPE.File, '', 0);
      store.taskStore.convertFile(fileData, type, cfg, async (result) => {
        if (result !== 'stop') {
          result.fileName = this.getTargetFileName(fileName, true, null);
          store.docStore.setIsConverted(true);
        }
        callback && callback(result);
      }, (err) => {
        error && error(err);
        if (process.env.NODE_ENV == 'development') {
          console.error("TCL: doConvertToPDF -> error", err);
        }
      }, showSpin);
    };

    if (confTextObj.waterMark && confTextObj.waterMark.image && confTextObj.waterMark.image.name && confTextObj.waterMark.image.dataURL) {
      const { name, dataURL } = confTextObj.waterMark.image;
      const imageFileData = new FileData(base64ToBlob(dataURL), name, DATA_TYPE.File, '', 0);
      const task = store.taskStore.createUploadTask(imageFileData, type, result => {
        if (result === 'stop') return;
        confTextObj.waterMark.image = result.data.docid;
        convertHandle({ confText: JSON.stringify(confTextObj) });
      });
      store.taskStore.doAddToTaskList(task);
    } else {
      convertHandle({ confText: JSON.stringify(confTextObj) });
    }
  }

    doPDFToTxt(callback, error){
        store.taskStore.setHasTask(true);
        fileController.getCurrentDocBuffer().then(([buffers,fileName])=>{
            let fileData = new FileData(buffers, fileName, DATA_TYPE.FileBuffer, '', 0);
            store.taskStore.convertFile(fileData, CONVERT_TYPE.PDFTOTXT, null, (result)=>{
                if (result!='stop') result.fileName = this.getTargetFileName(fileName, true, null);
                
                callback && callback(result);
            },(err)=>{
                if(process.env.NODE_ENV == 'development'){
                    console.error("TCL: doPDFToTxt -> error", err)
                    error && error(err);
                }
            })
        })
    }

    // 转换pdf版本号
    doConvertPDFVersion (fileInfo, toVersion, callback) {
        if (!toVersion) {
            const blob = new Blob(fileInfo.buffer, {type: 'application/octet-stream'});
            store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.FINISH, ret: 0, blob }, CONVERT_TYPE.PDFVERSION);
            store.taskStore.taskMessage.downloadName = fileInfo.fileName;
            callback && callback({ blob });
            return ;
        }
        store.taskStore.setHasTask(true);
        const {docInfo: {pdfVersion}} = store.docStore;
        const fileName = fileInfo.fileName;
        const cfg = {
            confText: JSON.stringify({ convert_to_version: toVersion || pdfVersion * 10 }),
            fileIndexList: "",
            overlayText: "",
            pageOrganizer: "",
            redactText: "",
            destFileName: fileName
        }
        store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, CONVERT_TYPE.PDFVERSION);
        const fileData = new FileData(fileInfo.buffer, fileName, DATA_TYPE.FileBuffer, '', 0);
        store.taskStore.convertFile(fileData, CONVERT_TYPE.PDFVERSION, cfg, (result)=>{
            if (result.url) {
                result.url = result.url.replace('filename=stream', 'filename=' + fileName);
                callback && callback(result);
            }
        }, err => {
            console.error('Convert Pdf Version Faile:', err);
        })
    }

    // 转换扫描文档
    doConvertScannedDocument ({ fileBuffer, pageRange, languages, is_editable, to_find_all_suspects, to_recognize_line_as_path, can_do_ocr = false }, callback) {
      const type = CONVERT_TYPE.OCR;
      store.taskStore.setHasTask(true);
      store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, type);
      fileController.getCurrentDocBuffer().then(([buffers, fileName]) => {
        const cfg = {
          confText: JSON.stringify({ 
            languages,
            is_editable,
            to_find_all_suspects,
            to_recognize_line_as_path,
            canDoOcr: can_do_ocr
          }),
          pageRange
        }
        const fileData = new FileData(fileBuffer || buffers, fileName, DATA_TYPE.FileBuffer, '', 0);
        store.taskStore.convertFile(fileData, type, cfg, (result) => {
          if (result.url) {
            result.url = result.url.replace('filename=stream', 'filename=' + fileName);
            store.taskStore.setHasTask(false);
            // 判断是否全部页面转换失败，是则报错，不允许打开
            const pdfDoc = pdfui.pdfViewer.currentPDFDoc;
            const pageCount = pdfDoc.getPageCount();
            let disablePages = result.data.disablePage;
            disablePages = (disablePages && disablePages.split(',')) || [];
            if (pageCount > 0 && (disablePages.length === pageCount)) {
              setTimeout(() => {
                store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.ERROR, url: '' }, type);  
              }, 100);
              callback && callback(result);
              return ;
            }
            store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.FINISH, url: '' }, type);
            fileController.doOpenFileByUrl(result.url, fileName, (err) => {
              console.error("doOpenFileByUrl -> err", err)
            }, '', () => {
              // success
              callback && callback(result);
            });
          }
        }, err => {
          store.taskStore.setHasTask(false);
          console.error('Convert Scanned Pdf Faile:', err);
        });
      });
    }

  createNewPortfolioDoc(fileList = [], title) {
    const i18n = pdfui.i18n;
    let queue = Promise.resolve();
    const files = [];
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      if (file.size > 1024 * 1024 * 256) {
        queue = queue.then(() => {
          return new Promise((resolve) => {
            pdfui.alert({ message: i18n.t('portfolio.addFilesTip1', { fileName: file.name }), level: 'warning' }).then(() => resolve());
          });
        });
      } else if (/\.(exe|msi|com)$/i.test(file.name)) {
        queue = queue.then(() => {
          return new Promise((resolve) => {
            pdfui.alert({ message: i18n.t('portfolio.addFilesTip2', { fileName: file.name }), level: 'warning' }).then(() => resolve());
          });
        });
      } else {
        queue = queue.then(() => {
          return new Promise((resolve) => {
            files.push(file);
            return resolve();
          });
        });
      }
    }
    queue.then(() => {
      const fullLang = store.appStore.lng.full === 'zh-CN' ? store.appStore.lng.full : 'en-US';
      getFileBufferByUrl(`/portfolio/coversheet/${fullLang}/coversheet.pdf`, (blob) => {
        pdfui.createNewPortfolioDoc(blob, files, title).then(() => store.appStore.doUpdateDocModified(true));
      });
    });
  }

  doConvertPDFPreflight({
    fileData,
    fileName,
    showSpin = true,
    params,
    title,
    callback,
    onError,
  }) {
    store.taskStore.setHasTask(true);
    const type = CONVERT_TYPE.PDFVERSION;
    const destFilename = `${fileName.replace('.pdf', '')}_${title.replace('PDF/', '')}.pdf`;
    showSpin && store.taskStore.onUpdateTaskMessage({
      fileName: destFilename,
      status: TASK_STATUS.BEGIN_UPLOAD,
      ret: 0
    }, type);
    store.taskStore.convertFile(fileData, type, { confText: JSON.stringify(params) }, result => {
      const { status, url, data: { percentage }} = result;
      if (status === 'task-step-finish' && percentage === 100) {
        result.url = url.replace('filename=stream', 'filename=' + destFilename);
        callback(result);
      }
    }, err => {
      if (process.env.NODE_ENV == 'development') {
        console.error("TCL: doConvertPDFPreflight -> error", err);
      }
      onError(err);
    })
  }

  // Save As ONLINERD-7187
  saveAsPDFPreflight({
    fileData,
    fileName,
    params,
  }) {
    return new Promise((resolve, reject) => {
      store.taskStore.setHasTask(true);
      const type = CONVERT_TYPE.PDFVERSION;
      const destFilename = `${fileName.replace('.pdf', '')}.pdf`;
      store.taskStore.onUpdateTaskMessage({
        fileName: destFilename,
        status: TASK_STATUS.BEGIN_UPLOAD,
        ret: 0
      }, type);
      store.taskStore.convertFile(fileData, type, { confText: JSON.stringify(params) }, result => {
        const { status, url, data: { percentage } } = result;
        if (status === 'task-step-finish' && percentage === 100) {
          result.url = url.replace('filename=stream', 'filename=' + destFilename);
          resolve(result);
        }
      }, reject)
    })
  }

  doPreflightProfiles({
    fileData,
    confText,
    fileName,
    showSpin = true,
    onSuccess,
    onError,
  }) {
    store.taskStore.setHasTask(true);
    const type = CONVERT_TYPE.PREFLIGHT_PROFILES;
    const cfg = { confText, destFilename: fileName };
    if (showSpin) {
      store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.WAITING, fileName, ret: 0 }, type);
    }
    store.taskStore.convertFile(fileData, type, cfg, result => {
      setTimeout(() => store.taskStore.setTaskMessage(null), 0);
      const { status, data: { percentage, xmlid, ...rest } } = result;
      if (status === 'task-step-finish' && percentage === 100) {
        const url = convertApis.doGetDownloadXml(xmlid, fileName)
        // resolve(url)
        const dist = Object.assign({}, result, {
          data: { ...result.data, url, ...rest },
        })
        onSuccess(dist);
      }
    }, err => {
      if (process.env.NODE_ENV == 'development') {
        console.error("TCL: doPreflightProfiles -> error", err);
      }
      onError(err);
    })
  }
}
